import { getBuilders } from '@/helpers/taskcards/builders';


const builders = getBuilders();

export async function buildCards(projectTasks, matchOnSchemaName = false) {

  const cards = [];

  projectTasks.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));

  for (const projectTask of projectTasks) {

    const builderEntry = matchOnSchemaName
      ? builders.find(b => b.schemaName === projectTask.schemaName)
      : builders.find(b => b.type === projectTask.taskType);

    if (builderEntry) {
      const card = await builderEntry.execute(projectTask.taskId);

      if(card == null) continue;
      
      cards.push(card);
    }

  }

  return cards;
}


export async function buildClientDetailsCard() {

  var builderEntry = builders.find(b => b.type === 'ClientDetails')

  return builderEntry ? await builderEntry.execute() : null;

}




export async function buildInternalCards() {
  const buildersToRun = ['DataSampleCollection', 'ParallelRun', 'Migration', 'PayrollHandover', 'GoLive'];

  const selectedBuilders = builders.filter(b => buildersToRun.includes(b.type));

  const results = await Promise.all(
    selectedBuilders.map(async (b) => {
      const r = await b.execute();
      return r;
    })
  );

  return results.filter(x => x !== null);
}